module.exports = __webpack_public_path__ + "static/media/image001-e1614098322734.fdbd1f7f.jpg";